import { render, staticRenderFns } from "./QuestionView.vue?vue&type=template&id=7b4047e9"
import script from "./QuestionView.vue?vue&type=script&lang=js"
export * from "./QuestionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports